import { StorePagination } from "../../../../DashboardPagination"
import { favoriteActions } from "../../../../../store/favorite-slice"

const Pagination = ({ index }) => {
    return <StorePagination index={index} sliceName="favorite" actions={favoriteActions} label="Favoriten Seitennavigation" />
}

export default Pagination;
